import http from '../utils/http';

export default {
    atribuirAtalhos(data) {
        return http.post({
            url: '/atalhos',
            data,
            lockMessage: 'Confirmando alterações de atalhos'
        });
    },

    buscarAtalhos() {
        return http.get({
            url: '/atalhos',
            lockScreen: false
        });
    },

    buscarAtalhosAgrupadosPorCategoria() {
        return http.get({ url: '/atalhos/agrupado-categoria' });
    }
};
